import MitLandingPage from '../pages/MitLandingPage.vue';

//USER
import MitHomePage from '../pages/MitHomePage.vue';
import MitMapsPage from '../pages/MitMapsPage.vue';

//MANAGER
import MitManageMapsPage from '../pages/manage/MitManageMapsPage.vue';
import MitManageMapPage from '../pages/manage/MitManageMapPage.vue';
import MitManageBuildingsPage from '../pages/manage/MitManageBuildingsPage.vue';
import MitManageBuildingPage from '../pages/manage/MitManageBuildingPage.vue';


//ADMIN
import MitAdminPage from '../pages/admin/MitAdminPage.vue';
import MitAdminSettingsPage from '../pages/admin/MitAdminSettingsPage.vue';
import MitAdminBuildingsSettingsPage from '../pages/admin/MitAdminBuildingsSettingsPage.vue';
import MitAdminSpacesUploadPage from '../pages/admin/MitAdminSpacesUploadPage.vue';

export const defaultRoute = 'home';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
  return [
    {
      path: '/landing',
      name: 'landing',
      component: MitLandingPage
    },
    {
      path: '/home',
      name: 'home',
      component: MitHomePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/maps/:buildingMitId',
      name: 'maps',
      component: MitMapsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
        path: '/manage/buildings',
        name: 'manage-buildings',
        component: MitManageBuildingsPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/manage/buildings/:buildingMitId',
        component: MitManageBuildingPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/manage/maps',
        name: 'manage-maps',
        component: MitManageMapsPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/manage/maps/:buildingMitId',
        component: MitManageMapPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/admin',
      name: 'admin',
      component: MitAdminPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
      },
    {
        path: '/admin/settings',
        name: 'admin-settings',
        component: MitAdminSettingsPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/admin/settings/buildings',
        name: 'admin-settings-buildings',
        component: MitAdminBuildingsSettingsPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/admin/spaces/upload',
        name: 'admin-spaces-upload',
        component: MitAdminSpacesUploadPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    }
  ];
}
